export const INCOTERM_CREATE_RESET = 'INCOTERM_CREATE_RESET'
export const INCOTERM_CREATE_SET_CREATED = 'INCOTERM_CREATE_SET_CREATED'
export const INCOTERM_CREATE_SET_ERROR = 'INCOTERM_CREATE_SET_ERROR'
export const INCOTERM_CREATE_SET_VIOLATIONS = 'INCOTERM_CREATE_SET_VIOLATIONS'
export const INCOTERM_CREATE_TOGGLE_LOADING = 'INCOTERM_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/incoterm/create/mutation_types.js